import { Stack, Typography } from '@mui/material';

import { CardNameContainer, ModelData, StatusContainer } from '../../styled';
import Actions from '../Actions';
import { usePinnedAPI } from '../hooks';
import TrainingJobsCountByStatusToChips from '../sections/TrainingJobsCountByStatusToChips';
import { CardProps } from './types';

function Card({ trainingProject }: CardProps) {
  const { getPinActionItem } = usePinnedAPI();

  return (
    <ModelData>
      <Stack gap={1.5} pt={2} pb={2.5} pl={2.5} pr={2} flex={1}>
        <Stack spacing={0.5}>
          <Stack direction="row" justifyContent="space-between">
            <CardNameContainer>
              <Typography variant="h4" noWrap>
                {trainingProject.name}
              </Typography>
            </CardNameContainer>
            <Stack direction="row" gap={0.2}>
              {getPinActionItem(trainingProject.id, trainingProject.name)}
              <Actions trainingProject={trainingProject} variant="minimal" />
            </Stack>
          </Stack>
        </Stack>
      </Stack>
      <StatusContainer>
        <Typography variant="h6">Jobs</Typography>
        <TrainingJobsCountByStatusToChips jobsCountByStatus={trainingProject.jobsCountByStatus} />
      </StatusContainer>
    </ModelData>
  );
}

export default Card;
